import ScrollTo from '../classes/ScrollTo';

export default function initScrollLinks() {
    document.querySelectorAll('[data-scroll-to]').forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();

            const target = document.querySelector(link.dataset.scrollTo);
            if (!target) return;

            new ScrollTo(target, {
                duration: 600,
                dist: -80 // si header fixed
            });
        });
    });
}
